

import React, { useState, useEffect } from "react";
import axios from "axios";

const CreateQuestionModal = ({ onClose, refreshQuestions, examData, classData ,admin }) => {

  const optionLabels = ["A", "B", "C", "D", "E"];

  const [formData, setFormData] = useState({
    class_id: classData.id,
    exam_title: "",
    status: "Open",
    total_questions: 0,
    option_count: 4,
    correct_marks: 4,
    wrong_marks: 0,
    penalty: 0,
    questions: []
  });


  useEffect(() => {

    if (!examData) return;

    const total = examData.total_questions || 0;

    const existingQuestions = examData.questions || [];

    const questionsArray = [];

    for (let i = 0; i < total; i++) {

      const existingQ = existingQuestions.find(q => q.question_no === i + 1);

      questionsArray.push({
        question_no: i + 1,
        answer: existingQ?.answer || "",
        correct_marks: existingQ?.correct_marks ?? examData.correct_marks ?? 4,
        wrong_marks: existingQ?.wrong_marks ?? examData.wrong_marks ?? ""
      });

    }

    setFormData({
      class_id: examData.class_id,
      exam_title: examData.exam_title || "",
      status: examData.status || "Open",
      total_questions: total,
      option_count: examData.option_count ?? 4,
      correct_marks: examData.correct_marks ?? 4,
      wrong_marks: examData.wrong_marks ?? "",
      penalty: examData.penalty ?? "",
      questions: questionsArray
    });

  }, [examData]);



  const handleChange = (e) => {

    const { name, value } = e.target;

    if (name === "total_questions") {

      const total = Number(value) || 0;

      const newQuestions = [];

      for (let i = 0; i < total; i++) {

        const existingQ = formData.questions[i];

        newQuestions.push({
          question_no: i + 1,
          answer: existingQ?.answer || "",
          correct_marks: existingQ?.correct_marks ?? formData.correct_marks,
          wrong_marks: existingQ?.wrong_marks ?? formData.wrong_marks
        });

      }

      setFormData({
        ...formData,
        total_questions: total,
        questions: newQuestions
      });

    }

    else if (name === "option_count") {

      setFormData({
        ...formData,
        option_count: Number(value)
      });

    }

    else {

      setFormData({
        ...formData,
        [name]: value
      });

    }

  };



  const handleSubmit = async (e) => {

    e.preventDefault();

    const payload = {

      ...formData,

      total_questions: Number(formData.total_questions),

      correct_marks: Number(formData.correct_marks),

      wrong_marks: Number(formData.wrong_marks || 0),

      penalty: Number(formData.penalty || 0),

      questions: formData.questions.map(q => ({
        question_no: q.question_no,
        answer: q.answer || null,
        correct_marks: Number(q.correct_marks ?? 0),
        wrong_marks: Number(q.wrong_marks ?? 0)
      }))

    };

    try {

      if (examData?.id) {

        await axios.put(`https://api.scannscore.com/edit_exam/${examData.id}`, payload);

        alert("Exam updated successfully");

      }

      else {

        const res = await axios.post("https://api.scannscore.com/create_exam", payload);

        alert(`Exam created successfully! ID : ${res.data.examId}`);

      }

      refreshQuestions?.();

      onClose();

    }

    catch (err) {

      console.log(err);

      alert(err.response?.data?.message || "Something went wrong");

    }

  };




// old working print
//   const handlePrint = () => {

// const options = ["A","B","C","D","E"].slice(0, formData.option_count);

// const answers = {};
// formData.questions.forEach(q => {
// answers[q.question_no] = q.answer;
// });

// const renderBlock = (start,end) => {

// let rows="";

// for(let i=start;i<=end;i++){

// rows += `<tr>

// <td class="qno">${i}</td>
// ${options.map(opt => `
// <td>
//   <div class="bubble ${answers[i]===opt ? "filled":""}">
//     ${opt}
//   </div>
// </td>
// `).join("")}
// </tr>`;


// }

// return rows;

// };

// const html = `
// <html>
// <head>
// <title>OMR Sheet</title>

// <style>

// @page{
//   size:A4;
//   margin:5mm;
// }

// body{
//   font-family:Arial;
//   color:#000;
//   margin:0;
//   padding:0;
// }

// /* 🔥 MAIN CONTAINER (IMPORTANT) */
// .omr-container{
//   position:relative;
//   padding:5mm; /* keeps markers safe from cut */
// }

// /* HEADER */
// .header{
//   text-align:center;
// }

// .header h2{
//   margin:0;
//   font-size:18px;
// }

// /* NAME */
// .blankline{
//   margin:5px 0 8px 0;
//   font-size:12px;
// }

// /* GRID */
// .grid{
//   display:grid;
//   grid-template-columns:repeat(4,1fr);
//   gap:10px;
// }

// /* BLOCK */
// .block{
//   border:1.5px solid black;
//   padding:4px;
// }

// /* TABLE */
// table{
//   border-collapse:collapse;
//   width:100%;
// }

// td{
//   padding:3.5px 1px;
//   text-align:center;
//   line-height:15px;
// }

// /* QUESTION */
// .qno{
//   font-weight:bold;
//   width:22px;
//   font-size:13px;
// }

// /* BUBBLE */
// .bubble{
//   width:15px;
//   height:15px;
//   border:1.5px solid black;
//   border-radius:50%;
//   margin:auto;
//   display:flex;
//   align-items:center;
//   justify-content:center;
//   font-size:9px;
// }

// /* FILLED */
// .filled{
//   background:black !important;
//   color:black;
//   -webkit-print-color-adjust: exact;
//   print-color-adjust: exact;
// }

// /* 🔥 CORNER MARKERS (FIXED) */
// .corner{
//   position:absolute;
//   width:20px;
//   height:20px;
//   border:5px solid black;
//   box-sizing:border-box;
//   z-index:9999;
// }

// /* ALIGN WITH CONTAINER */
// .tl{
//   top:0;
//   left:0;
//   border-right:none;
//   border-bottom:none;
// }

// .tr{
//   top:0;
//   right:0;
//   border-left:none;
//   border-bottom:none;
// }

// .bl{
//   bottom:0;
//   left:0;
//   border-right:none;
//   border-top:none;
// }

// .br{
//   bottom:0;
//   right:0;
//   border-left:none;
//   border-top:none;
// }

// @media print{
//   body{
//     margin:0;
//   }
// }

// </style>
// </head>

// <body>

// <div class="omr-container">

//   <!-- 🔥 MARKERS INSIDE CONTAINER -->
//   <div class="corner tl"></div>
//   <div class="corner tr"></div>
//   <div class="corner bl"></div>
//   <div class="corner br"></div>

//   <div class="header">
//     <h2>SCAN N SCORE</h2>
//   </div>

//   <div class="blankline">
//     Name: ____________________________
//   </div>

//   <div class="grid">

//     <div class="block">
//       <table>${renderBlock(1,40)}</table>
//     </div>

//     <div class="block">
//       <table>${renderBlock(41,80)}</table>
//     </div>

//     <div class="block">
//       <table>${renderBlock(81,120)}</table>
//     </div>

//     <div class="block">
//       <table>${renderBlock(121,160)}</table>
//     </div>

//   </div>

// </div>

// </body>
// </html>
// `;
// const win = window.open("","_blank");
// win.document.write(html);
// win.document.close();
// win.print();
// };

  const handlePrint = () => {

// const options = ["A","B","C","D","E"].slice(0, formData.option_count);
const options = ["A","B","C","D","E"];

const answers = {};
formData.questions.forEach(q => {
answers[q.question_no] = q.answer;
});

const renderBlock = (start,end) => {

let rows="";

for(let i=start;i<=end;i++){

rows += `<tr>

<td class="qno">${i}</td>
${options.map(opt => `
<td>
  <div class="bubble ${answers[i]===opt ? "filled":""}">
    ${opt}
  </div>
</td>
`).join("")}
</tr>`;


}

return rows;

};

const html = `
<html>
<head>
<title>OMR Sheet</title>

<style>

@page{
  size:A4;
  margin:0mm 8mm 8mm 8mm;
}

body{
  font-family:Arial;
  color:#610000;
  margin:0;
  padding:0;
}

/* 🔥 MAIN CONTAINER (IMPORTANT) */
.omr-container{
  position:relative;
  padding:5mm;
}

/* HEADER */
.header{
  text-align:center;
}

.header h2{
  margin:0;
  font-size:17px;
}

.header h6{
  margin:0 0 0.5em 0;
  font-size:14px;
}

/* NAME */
.blankline{
  margin:5px 0 8px 0;
  font-size:12px;
}

/* GRID */
.grid{
  display:grid;
  grid-template-columns:repeat(4,1fr);
  gap:10px;
}

/* BLOCK */
.block{
  border:1.5px solid black;
  padding:4px;
}

/* TABLE */
table{
  border-collapse:collapse;
  width:100%;
}

td{
  padding:3.3px 1px;
  text-align:center;
}

/* QUESTION */
.qno{
  font-weight:bold;
  width:22px;
  font-size:13px;
}

/* BUBBLE */
.bubble{
  width:15px;
  height:15px;
  border:1.5px solid black;
  border-radius:50%;
  margin:auto;
  display:flex;
  align-items:center;
  justify-content:center;
  font-size:9px;
}

/* FILLED */
.filled{
  background:black !important;
  color:black;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}

/* 🔥 CORNER MARKERS (FIXED) */
.corner{
  position:fixed;
  width:35px;
  height:35px;
  background: black;
  border:10px solid black;
  box-sizing:border-box;
  z-index:9999;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
  }

/* ALIGN WITH CONTAINER */
.tl{
  top:0mm;
  left:0mm;
  border-right:none;
  border-bottom:none;
}

.tr{
  top:0mm;
  right:0mm;
  border-left:none;
  border-bottom:none;
}

.bl{
  bottom:6mm;
  left:0mm;
  border-right:none;
  border-top:none;
}

.br{
  bottom:6mm;
  right:0mm;
  border-left:none;
  border-top:none;
}

@media print{
  body{
    margin:0;
  }
  .corner{
  background: black;
  }
}

</style>
</head>

<body>



  <div class="corner tl"></div>
  <div class="corner tr"></div>
  <div class="corner bl"></div>
  <div class="corner br"></div>

  <div class="omr-container">



  <div class="header">
  <h2>${formData.exam_title ?? 'Exam Sheet'}</h2>
    <h6>SCAN N SCORE</h6>
  </div>


  <div class="grid">

    <div class="block">
      <table>${renderBlock(1,40)}</table>
    </div>

    <div class="block">
      <table>${renderBlock(41,80)}</table>
    </div>

    <div class="block">
      <table>${renderBlock(81,120)}</table>
    </div>

    <div class="block">
      <table>${renderBlock(121,160)}</table>
    </div>

  </div>

</div>

</body>
</html>
`;
const win = window.open("","_blank");
win.document.write(html);
win.document.close();
win.print();

};




  const handleUpdateAnswerKey = async () => {

    try {

      const payload = {

        exam_id: examData?.id,

        questions: formData.questions.map(q => ({

          id: q.id || null,

          question_no: Number(q.question_no),

          answer: q.answer || null,

          correct_marks: Number(q.correct_marks ?? formData.correct_marks ?? 4),

          wrong_marks: Number(q.wrong_marks ?? formData.wrong_marks ?? 0)

        }))

      };

      await axios.put(
        `https://api.scannscore.com/update_answer_key/${examData?.id}`,
        payload
      );

      alert("Answer key updated successfully");

      refreshQuestions?.();

      onClose();

    }

    catch (err) {

      console.log(err);

      alert(err.response?.data?.message || "Update failed");

    }

  };



    const handleAddAnswerKey = async () => {

    try {

      const payload = {

        exam_id: examData?.id,

        questions: formData.questions.map(q => ({

          id: q.id || null,

          question_no: Number(q.question_no),

          answer: q.answer || null,

          correct_marks: Number(q.correct_marks ?? formData.correct_marks ?? 4),

          wrong_marks: Number(q.wrong_marks ?? formData.wrong_marks ?? 0)

        }))

      };

      await axios.post(
        `https://api.scannscore.com/add_answer_key/${examData?.id}`,
        payload
      );

      alert("Answer key Added successfully");

      refreshQuestions?.();

      onClose();

    }

    catch (err) {

      console.log(err);

      alert(err.response?.data?.message || "Update failed");

    }

  };



  return (

    <div
      className="modal-backdrop d-flex justify-content-center align-items-center"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        overflowY: 'auto',
        background: "rgba(0,0,0,0.5)",
        zIndex: 1050
      }}
    >

      <div className="card p-4" style={{ width: "900px",             maxWidth: "95%",
      maxHeight: "90vh",
      overflowY: "auto",  
        scrollbarWidth: "none",  
    msOverflowStyle: "none",
            boxShadow: "0 8px 20px rgba(0,0,0,0.2)", }}>

        <div className="d-flex justify-content-between mb-3">

          <h5>{examData ? "Edit Exam" : "Create Exam"}</h5>

          <button className="btn btn-outline-secondary" onClick={onClose}>X</button>

        </div>



        <form onSubmit={handleSubmit}>

          <div className="mb-3">

            <label className="form-label">Exam Title</label>

            <input
              type="text"
              name="exam_title"
              className="form-control"
              value={formData.exam_title}
              onChange={handleChange}
              required
            />

          </div>



          <div className="row g-3">

            <div className="col-md-6">

              <label>Status</label>

              <select
                name="status"
                className="form-select"
                value={formData.status}
                onChange={handleChange}
                 required
              >

                <option value="Draft">Draft</option>
                <option value="Open">Open</option>
                <option value="Close">Close</option>

              </select>

            </div>



            <div className="col-md-6">

              <label>Total Questions</label>

              <input
                type="number"
                name="total_questions"
                className="form-control"
                value={formData.total_questions}
                onChange={handleChange}
                 
              />

            </div>

          </div>



          <div className="row g-3 mt-3">

            <div className="col-md-3">

              <label>Options</label>

              <select
                name="option_count"
                className="form-select"
                value={formData.option_count}
                onChange={handleChange}
                 required
              >

                {[4, 5].map(opt => (
                  <option key={opt} value={opt}>
                    {opt} ({optionLabels.slice(0, opt).join(",")})
                  </option>
                ))}

              </select>

            </div>



            <div className="col-md-3">

              <label>Correct (+)</label>

              <input
                type="number"
                name="correct_marks"
                className="form-control"
                value={formData.correct_marks}
                onChange={handleChange}
                 required
              />

            </div>



            <div className="col-md-3">

              <label>Wrong (-)</label>

              <input
                type="number"
                name="wrong_marks"
                className="form-control"
                value={formData.wrong_marks}
                onChange={handleChange}
              />

            </div>



            <div className="col-md-3">

              <label>Penalty</label>

              <input
                type="number"
                name="penalty"
                className="form-control"
                value={formData.penalty}
                onChange={handleChange}
              />

            </div>

          </div>





          <div className="mt-4">

            <h6>Answer Sheet</h6>

            <div style={{ maxHeight: "400px", overflowY: "auto", border: "1px solid #ddd" }}>

              <table id="answer-key-table" className="table table-bordered text-center">

                <thead>

                  <tr>

                    <th>Q.No</th>

                    {optionLabels.slice(0, formData.option_count).map(opt => (
                      <th key={opt}>{opt}</th>
                    ))}

                    <th>+ Mark</th>
                    <th>- Mark</th>

                  </tr>

                </thead>



                <tbody>

                  {formData.questions.map((q, idx) => (

                    <tr key={idx}>

                      <td>{q.question_no}</td>

                      {optionLabels.slice(0, formData.option_count).map(opt => (
                        <td key={opt}>
                          <input
                            type="radio"
                            name={`question_${q.question_no}`}
                            checked={q.answer === opt}
                            onChange={() => {
                              const updated = [...formData.questions];
                              updated[idx].answer = opt;
                              setFormData({ ...formData, questions: updated });
                            }}
                          />
                        </td>
                      ))}

                      <td>

                        <input
                          type="number"
                          className="form-control"
                          value={q.correct_marks}
                          onChange={(e) => {
                            const updated = [...formData.questions];
                            updated[idx].correct_marks = e.target.value;
                            setFormData({ ...formData, questions: updated });
                          }}
                        />

                      </td>

                      <td>

                        <input
                          type="number"
                          className="form-control"
                          value={q.wrong_marks}
                          onChange={(e) => {
                            const updated = [...formData.questions];
                            updated[idx].wrong_marks = e.target.value;
                            setFormData({ ...formData, questions: updated });
                          }}
                        />

                      </td>

                    </tr>

                  ))}

                </tbody>

              </table>

            </div>

          </div>



          <div className="d-flex justify-content-between mt-4">

            {examData && 
              <button type="button" className="btn btn-info" onClick={handlePrint}>
                Print Answer Key
              </button>
            }

            <div className="d-flex gap-2">

              <button type="submit" className="btn btn-primary">
                {examData ? "Update Exam" : "Submit Exam"}
              </button>

{examData && examData?.is_ques != "Yes" &&
<button
    type="button"
    className="btn btn-warning"
    onClick={handleAddAnswerKey}
  >
    Add Answer Key
  </button>
}

{ examData?.is_ques == "Yes" &&
<>
            {examData && admin.role === "admin" && (
  <button
    type="button"
    className="btn btn-warning"
    onClick={handleUpdateAnswerKey}
  >
    Update Answer Key
  </button>
)}
</>
}
            </div>

          </div>

        </form>

      </div>

    </div>

  );

};

export default CreateQuestionModal;



